module.exports = __webpack_public_path__ + "static/lights7-3a42a6233f621401bf15027e91aceebb.jpg";